class LineGraphDisplayOptions {
    constructor(color, thickness, dotThickness) {
        this.color = color || black;
        this.thickness = thickness || 1;
        this.dotThickness = dotThickness || 1;
    }
}
export default LineGraphDisplayOptions;